import { Outlet } from "react-router-dom";
const Content = () => {
  return (
    
      <Outlet></Outlet>
    
  );
};

export default Content;
